import React, { Component } from "react";
import { number } from "prop-types";
import { withTheme } from "styled-components";
import { CaretUpSmall, CaretDownSmall } from "@vitalsource/vstui-icons";
import { CSSTransition } from "react-transition-group";

export class Accordion extends Component {
  constructor() {
    super();
    this.state = { expanded: false };
    this.toggleExpanded = this.toggleExpanded.bind(this);
  }

  toggleExpanded() {
    this.setState(
      prevState => ({ expanded: !prevState.expanded }),
      () => {
        this.props.onToggle && this.props.onToggle(this.state.expanded);
      }
    );
  }

  render() {
    return (
      <CSSTransition
        in={this.state.expanded}
        classNames="accordion-slide"
        timeout={{ enter: 500, exit: 500 }}
      >
        <div {...this.props}>
          {React.Children.map(this.props.children, child => {
            if (
              ["AccordionButton"].find(el => el === child.type.accordionRole)
            ) {
              return React.cloneElement(child, {
                "aria-expanded": this.state.expanded,
                onClick: this.toggleExpanded,
                className: this.props.archived ? "archived" : ""
              });
            } else if (
              ["AccordionContent"].find(el => el === child.type.accordionRole)
            ) {
              return React.cloneElement(child, {
                "aria-hidden": !this.state.expanded
              });
            }
            return child;
          })}
        </div>
      </CSSTransition>
    );
  }
}

export const AccordionButton = props => {
  const Tag = `h${props.level}`;
  return (
    <Tag>
      <button {...props}>
        {React.Children.map(props.children, child => {
          if (
            ["Caret"].find(
              el => el === (child.type && child.type.accordionRole)
            )
          ) {
            return React.cloneElement(child, {
              expanded: props["aria-expanded"]
            });
          }
          return child;
        })}
      </button>
    </Tag>
  );
};

Accordion.propTypes = { level: number };

AccordionButton.accordionRole = "AccordionButton";

export const AccordionContent = props => {
  return <div {...props}>{props["aria-hidden"] ? null : props.children}</div>;
};

export const Caret = withTheme(({ expanded, ...props }) => {
  const Component = expanded ? CaretUpSmall : CaretDownSmall;
  return <Component color={props.theme.color.primary.getShade(7)} {...props} />;
});

Caret.accordionRole = "Caret";

AccordionContent.accordionRole = "AccordionContent";
